module.exports = __webpack_public_path__ + "static/media/homepage-symptoms.46254537.png";